import { Component, ViewEncapsulation, ViewChild, TemplateRef, ElementRef, OnInit, AfterContentInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { messageService } from 'src/app/message.service';
import { PaginationService } from 'src/app/PaginationService';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';

export interface DmsGroupsInterface {
  groupId: number;
  groupName: string;
  groupDescription: string;
  isActive: string;
  updateReason: string;
  createdByName: string;
  createdOn: Date;
  updatedByName: string;
  updatedOn: Date;
}

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class GroupsComponent implements OnInit, AfterContentInit {

  getDmsGroupsDetailsTableData: any = [];
  getDmsGroupsDetailsTableDataTemp: any = [];
  searchByUserName: any = null;

  auditTrail: any = {};
  visibleAuditTrail: boolean = false;

  constructor(public dialog: MatDialog, private readonly appService: AppService,
    public router: Router, private readonly snackBar: MatSnackBar, private readonly elem: ElementRef, public message: messageService, public paginationService: PaginationService) { }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  allowOnlyAllowedChars(event: KeyboardEvent): void {
    const allowedPattern = /^[A-Za-z0-9\s\-._()/\\]$/;

    const inputChar = event.key;

    if (inputChar.length === 1 && !allowedPattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  ngOnInit() {

    this.getcallMethod();
  }

  isProcessing: boolean = false;
  PageName: any;
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  searchValue: any;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  pager: any = {};
  pagedItems: any[];
  error = '';
  makeStickyColumns: any;
  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  documentTypeCall: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  statusCodeValue: any;
  columnLists: any = {};
  dataTypeList: any = [];
  array: any = [];
  visibleEditButton: boolean;
  dropDownForModules: any;
  popupTitle: any;
  flexifieldSetupList: any;
  docTypeData: any;
  docTypeStageList: any;
  docTypeValueDropdown: any;
  selectDocTypeName: any;
  selectedDocTypeCodeValue: any;
  selectedDocTypeNameValue: any;

  selectModule: any;
  selectModuleName: any;
  selectedmoduleValue: any;
  moduleValueDropdown: any = [];

  selectFlexifield: any;
  selectFlexifieldName: any;
  selectFlexifieldsValue: any;
  flexifieldsValueDropdown: any;
  onFlexifieldsSelect(item: any) {
    this.selectFlexifield = item.valueExp;
    this.selectFlexifieldName = item.displayExp;
  };
  onFlexifieldsRemoved(item: any) { };

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }
  setPage(page: number, targetpage: number) {
    if (Number.isNaN(page) || page < 1) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.documentTypeCall.length, page, this.perPage, targetpage);

    if (page > this.pager.totalPages) {
      return;
    }
    this.pagedItems = this.documentTypeCall.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  dataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked === true;

    this.childCheckBoxs = isChecked;

    for (const doc of this.documentTypeCall) {
      doc.childCheckBoxs = isChecked;
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.documentTypeCall[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.GROUP_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.priviousSelectedValue = idx;
    this.visibleAuditTrail = this.documentTypeCall.some((list: any) => list.childCheckBoxs);
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }

    })

  }

  private processCheckboxColumns(): void {
    const checkboxColumns = this.dataTypeList
      .filter((item: any) => item.fieldType === 'CHECKBOX')
      .map((item: any) => item.columnName);

    for (const document of this.documentTypeCall) {
      for (const colName of checkboxColumns) {
        document[colName] = document[colName] === "Y";
      }
    }
  }
  private createDataTypeMap(list: any[]): Map<string, string> {
    return new Map(list.map(t => [t.columnName, t.fieldType]));
  }

  private updateColumnDataTypes(dataTypeMap: Map<string, string>): void {
    for (const [m, colName] of this.columnLists.columnsListarray.entries()) {
      const fieldType = dataTypeMap.get(colName);
      if (fieldType) {
        this.columnLists.columnsListarray1[m].dataType = fieldType;
      }
    }
  }

  getcallMethod() {
    this.isProcessing = true;
    this.designationCodeValue = null;
    this.departmentCodeValue = null;
    this.statusCodeValue = null;

    this.documentTypeCall = [];
    const data = {

      gridName: "DMS_GROUP"
    }

    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        response.orderByClause ??= "";


        this.makeStickyColumns = response.fixedFieldCnt;

        const data1: any = {

          gridName: "DMS_GROUP",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          status: this.statusCodeValue,
          codelistGroup: null,
          manualEntryDataFields: response.manualEntryDataFields
        }

        this.reportObj = { ...data1, ...data };
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.documentTypeCall = response1;
            this.visibleAuditTrail = false;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;


            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(`${size}px`);
            }

            const invisibleSet = new Set(this.columnLists.invisibleColumnarray);

            for (let y = this.columnLists.columnsListarray.length - 1; y >= 0; y--) {
              const columnName = this.columnLists.columnsListarray[y];

              if (invisibleSet.has(columnName)) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              }
            }

            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                this.columnLists.columnsListarray1 = [];
                this.dataTypeList = response2;

                const dataTypeMap = this.createDataTypeMap(this.dataTypeList);

                for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                  this.columnLists.columnsListarray1.push({
                    columnsListarray: this.columnLists.columnsListarray[m],
                    dataType: "textbox",
                    width: this.columnLists.fieldSizeListArray[m]
                  });
                }

                this.updateColumnDataTypes(dataTypeMap);
              }
              this.processCheckboxColumns();
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.setPage(1, 0);
            });
            this.message.gridList = this.documentTypeCall;
            this.collectionSize = this.documentTypeCall.length;
            this.labelcall();
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }


  label: any = [];
  dynamicLabel: any = null;
  labelcall() {
    this.isProcessing = true;
    let data = {
      tableName: 'DMS_GROUPS_VW',
      moduleName: null,
      gridName: 'DMS_GROUP',
      groupId: 0
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (data: any) => {
        this.label = data;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = user.changedFieldName;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.documentTypeCall.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.documentTypeCall.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  refreshGridData() {
    this.ngOnInit();
  }

  hyperLinkFlag: boolean;
  ngAfterContentInit() {
    this.hyperLinkFlag = true;
  }

  groupName: any;
  updateReason: any;
  groupNameRequiredMsg: any;
  updateReasonRequiredMsg: any;

  fieldValidation() {
    this.groupName = document.getElementById('groupName') as HTMLInputElement;
    this.updateReason = document.getElementById('updateReason') as HTMLInputElement;

    this.groupNameRequiredMsg = document.getElementById('groupName-required-msg') as HTMLInputElement;
    this.updateReasonRequiredMsg = document.getElementById('updateReason-required-msg') as HTMLInputElement;

    if (this.dmsGroupsFieldData.groupName == "") {
      this.groupName.style.border = '1px solid red';
      this.groupNameRequiredMsg.style.display = 'block';
    } else {
      this.groupName.style.border = 'none';
      this.groupNameRequiredMsg.style.display = 'none';
    }

    if (this.operationFlag == 'EDIT') {
      if (this.dmsGroupsFieldData.groupName != this.previousData.groupName || this.dmsGroupsFieldData.groupDescription != this.previousData.groupDescription ||
        this.isActiveValue != this.previousData.isActive) {

        this.updateReason.style.border = '1px solid red';
        this.updateReasonRequiredMsg.style.display = 'block';
      } else {
        this.updateReason.style.border = 'none';
        this.updateReasonRequiredMsg.style.display = 'none';
      }
    }
  }

  onFieldFocusout() {
    if (this.groupName.value) {
      this.groupName.style.border = 'none';
      this.groupNameRequiredMsg.style.display = 'none';
    } else {
      this.groupName.style.border = '1px solid red';
      this.groupNameRequiredMsg.style.display = 'block';
    }
  }

  dmsGroupsFieldData: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('updateMessagePopup', { static: true }) updateMessagePopup: TemplateRef<any>;

  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleUpdateMessagePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  updateMessagePopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  isActiveToggerBoxValue: boolean;
  isActiverFunction(isTagged: boolean): void {
    this.isActiveToggerBoxValue = isTagged;
  }

  visibleAddButton: boolean;
  visibleReasonForUpdateField: boolean;

  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleReasonForUpdateField = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create Groups";
    this.dmsGroupsFieldData.groupName = '';
    this.dmsGroupsFieldData.groupDescription = '';
    this.dmsGroupsFieldData.isActive = true;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  previousData: any;
  previousDataGroupId: any;
  openEditPopup(editRowData: any) {
    this.isProcessing = true;
    this.previousData = editRowData;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.visibleReasonForUpdateField = true;
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = "Update Groups";
    this.previousDataGroupId = editRowData.groupId;
    this.appService.getDmsGroupsVwDetails().subscribe((response: any) => {
      this.getDmsGroupsDetailsTableData = response
      for (const group of this.getDmsGroupsDetailsTableData) {
        if (this.previousDataGroupId === group.groupId) {
          this.dmsGroupsFieldData.groupId = group.groupId;
          this.dmsGroupsFieldData.groupName = group.groupName;
          this.dmsGroupsFieldData.groupDescription = group.groupDescription;

          this.dmsGroupsFieldData.isActive = group.isActive === 'Y';

          break;
        }
      }
      this.isProcessing = false;
    })
    this.dmsGroupsFieldData.updateReason = null;
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  isActiveValue: any;

  addAndEditFunction(dmsGroupsFieldData: any) {
    this.isProcessing = true;
    this.isActiveValue = dmsGroupsFieldData.isActive ? 'Y' : 'N';
    if (dmsGroupsFieldData.groupName == "") {
      this.fieldValidation();
      this.isProcessing = false;
    } else {
      let data = {

        groupName: dmsGroupsFieldData.groupName,
        groupDescription: dmsGroupsFieldData.groupDescription,
        isActive: dmsGroupsFieldData.isActive ? 'Y' : 'N',
      }
      if (this.operationFlag == 'ADD') {

        this.appService.createDmsGruoups(data).subscribe({
          next: (Response: any) => {
            this.displayMessage = Response.result;
            this.displayResultType = Response.resultType;
            if (this.displayResultType == 'S') {
              this.visibleAddAndEditPopup.close();
              this.isProcessing = false;
              this.ngOnInit();
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      } else {

        if (this.dmsGroupsFieldData.updateReason == null || this.dmsGroupsFieldData.updateReason == undefined) {
          if (dmsGroupsFieldData.groupName != this.previousData.groupName || dmsGroupsFieldData.groupDescription != this.previousData.groupDescription ||
            this.isActiveValue != this.previousData.isActive) {
            this.fieldValidation();
            this.isProcessing = false;
          } else {
            this.fieldValidation();
            this.visibleUpdateMessagePopup = this.dialog.open(this.updateMessagePopup, this.updateMessagePopupConfig);
            setTimeout(() => {
              this.visibleUpdateMessagePopup.close();
            }, 1000);
            this.isProcessing = false;
          }
        } else {
          delete dmsGroupsFieldData.createdOn;
          delete dmsGroupsFieldData.updatedOn;

          let modifiedData = {
            ...data,
            updateReason: dmsGroupsFieldData.updateReason
          }
          this.appService.updateDmsGroups(modifiedData).subscribe({
            next: (Response: any) => {
              this.displayMessage = Response.result;
              this.displayResultType = Response.resultType;
              if (this.displayResultType == 'S') {
                this.visibleAddAndEditPopup.close();
                this.isProcessing = false;
                this.ngOnInit();
              }
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: Response.result,
                  type: Response.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok"
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
            }, error: (error) => {
              this.displayMessage = error;
              this.displaySuccessMessage = false;
              this.displayErrorMessage = true;
              this.isProcessing = false;
              throw error;
            }
          });
        }
      }
    }

    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  hyperLinkFunction() {
    if (this.hyperLinkFlag) {
      this.hyperLinkFlag = false;
      let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-header');
      let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-column');
      elements1.forEach((header: any) => {
        header.style.position = 'sticky';
        header.style.left = '60px';
      })

      elements2.forEach((column: any, key: any) => {
        elements2[key].style.position = 'sticky';
        elements2[key].style.background = 'white';
        elements2[key].style.textDecoration = "underline";
        elements2[key].style.color = "blue";
        elements2[key].style.cursor = "pointer";
        elements2[key].style.left = '60px';

        elements2[key].addEventListener('click', this.onClick.bind(this));
      })
    }

  }

  onClick(event: any) {
    let groupName = event.target.textContent.trim();
    const selectedGroup = this.documentTypeCall.find((x: any) => x.GROUP_NAME.trim() === groupName);

    if (selectedGroup) {
      this.message.masterDetails = [selectedGroup];
      sessionStorage.setItem('selectedDmsGroupId', selectedGroup.GROUP_ID);

      this.router.navigate(['dashboard/groupUsers']);
    } else {
      console.error('Group not found. Ensure grid data matches displayed name.');
      this.snackBar.open("Error navigating: Group data not found", "OK", { duration: 3000 });
    }
  }
  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteDmsGroupId: any;
  openDeletePopup(deleteRowData: any) {
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Groups";
    this.deleteDmsGroupId = deleteRowData.GROUP_ID;
    if (this.dmsGroupsFieldData.deleteReason != undefined) {
      this.dmsGroupsFieldData.deleteReason = '';
    }
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      let data = {

        groupId: this.deleteDmsGroupId,
        deleteReason: this.dmsGroupsFieldData.deleteReason,
      }
      this.appService.deleteDmsGroups(data).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {

            this.ngOnInit();
          }
          this.isProcessing = false;
          this.visibleDeletePopup.close();
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });

        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.documentTypeCall.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, group: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : group.GROUP_ID;
    this.auditTrail.gridName = 'DMS_GROUP';
    this.auditTrail.report_And_Popup_Name = 'DMS Group Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(group);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'Documents Group Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  };
  focusEmpty() {
    console.log();
  }
}
